
// import React, { useEffect, useState } from 'react';
// import { Pencil, Trash, Plus, Search, Mail, Phone, FileText, Eye } from 'lucide-react';
// import { useAdmin } from '../AdminLayout/AdminProvider';
// import axios from 'axios';

// import { State, City } from "country-state-city";
// import Modal from "react-modal";





// Modal.setAppElement("#root");


// const API_BASE = "https://api.propertygalleria.in/master/api";
// const API_BASEE = "http://localhost:4001";




// export const InvestorLead = () => {
//     const { associates, InvestorLead, projects, addAssociate, updateAssociate, deleteAssociate, fetchAssociates, fetchInvestorLead } = useAdmin();
//     const [isFormOpen, setIsFormOpen] = useState(false);
//     const [editingAssociate, setEditingAssociate] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [otpSent, setOtpSent] = useState(false);
//     const [otp, setOtp] = useState("");
//     const [aadharVerified, setAadharVerified] = useState(false);
//     const [loadingOtp, setLoadingOtp] = useState(false);

//     console.log('this InvestorLeads', InvestorLead)

//     const [formData, setFormData] = useState({
//         full_name: '',
//         email: '',
//         mobile_number: '',
//         property_id: '',
//         handling_agent_id: '',
//         aadharKyc: null,
//         experience_years: '',
//         state:"",
//         city:"",
//         investment_range:""
//     });


//     const sendAadharOtp = async () => {
//         if (formData.aadharKyc.length !== 12) {
//             alert("Enter valid 12-digit Aadhaar number");
//             return;
//         }

//         try {
//             setLoadingOtp(true);
//             await axios.post(`${API_BASE}/api/send-aadhar-otp`, {
//                 Aadhar_No: formData.aadharKyc,
//             });
//             setOtpSent(true);
//             alert("OTP sent successfully");
//         } catch (err) {
//             alert("Failed to send OTP");
//         } finally {
//             setLoadingOtp(false);
//         }
//     };



//     const verifyAadharOtp = async () => {
//         if (!otp) {
//             alert("Enter OTP");
//             return;
//         }

//         try {
//             await axios.post(`${API_BASE}/api/verify-aadhar-otp`, {
//                 otp,
//                 Aadhar_No: formData.aadharKyc,
//             });

//             setAadharVerified(true);
//             alert("Aadhaar verified successfully");
//         } catch (err) {
//             alert("OTP verification failed");
//         }
//     };


//     // ✅ CREATE LEAD
//     const addLead = async (leadData) => {
//         console.log('this is leadData', leadData)
//         try {
//             await axios.post(`${API_BASE}/api/leads`, {
//                 name: leadData.full_name,
//                 email: leadData.email,
//                 mobile: leadData.mobile_number,
//                 aadhar: leadData.aadhaar_number || null,
//                 property_id: leadData.property_id || null,
//                 property_title: leadData.property_title || null,
//                 handling_agent_id: leadData.handling_agent_id || null,
//                 investmentRange: leadData.investment_range || null,
//                 location: null,
//                 remarks: null,
//                 status: "new",
//                 state:leadData.state,
//                 city:leadData.city
//             });

//             fetchInvestorLead();
//         } catch (err) {
//             console.error(err);
//             alert("Failed to create lead");
//         }
//     };


//     // ✅ UPDATE LEAD
//     const updateLead = async (leadId, leadData) => {

//         console.log('this is leadID', leadId)
//         console.log('this is leadData', leadData)
//         try {
//             await axios.put(`${API_BASE}/api/leads/${leadId}`, {
//                 status: leadData.status || "new",
//                 remarks: leadData.remarks || null,
//                 investmentRange: null,
//                 location: null,
//                 property_id: leadData.property_id || null,
//                 property_title: leadData.property_title || null,
//                 handling_agent_id: leadData.handling_agent_id || null,
//             });

//             fetchInvestorLead();
//         } catch (err) {
//             console.error(err);
//             alert("Failed to update lead");
//         }
//     };


//     // const handleSubmit = (e) => {
//     //     e.preventDefault();

//     //     //     if (!aadharVerified) {
//     //     //   alert("Please verify Aadhaar before submitting");
//     //     //   return;
//     //     // }


//     //     if (!formData.full_name || !formData.email || !formData.mobile_number || !formData.property_id) {
//     //         alert('Please fill all required fields');
//     //         return;
//     //     }

//     //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     //     if (!emailRegex.test(formData.email)) {
//     //         alert('Please enter a valid email address');
//     //         return;
//     //     }

//     //     const mobileRegex = /^[0-9]{10}$/;
//     //     if (!mobileRegex.test(formData.mobile_number)) {
//     //         alert('Please enter a valid 10-digit mobile_number number');
//     //         return;
//     //     }

//     //     const selectedProject = projects.find(
//     //         (p) => p.id === Number(formData.property_id)
//     //     );

//     //     const leadData = {
//     //         role: "agent",
//     //         full_name: formData.full_name,
//     //         email: formData.email,
//     //         mobile_number: formData.mobile_number,


//     //         property_id: Number(formData.property_id),          // ✅ ADD
//     //         handling_agent_id: Number(formData.handling_agent_id), // ✅ ADD


//     //         aadhaar_number: formData.aadharKyc || undefined,

//     //         aadhaar_verified: "1",
//     //         experience_years: formData.experience_years,         // or from input if you add it
//     //         project_name: selectedProject?.project_name || "",
//     //         is_admin_approve: 1          // 👈 always 1
//     //     };


//     //     if (editingAssociate) {
//     //         updateLead(editingAssociate.associate_code, leadData);
//     //         alert('Associate updated successfully');
//     //     } else {
//     //         addLead(leadData);
//     //         alert('Associate created successfully');
//     //     }

//     //     resetForm();
//     // };

//     const handleSubmit = (e) => {
//         e.preventDefault();

//         if (!formData.full_name || !formData.mobile_number) {
//             alert("Name and Mobile are required");
//             return;
//         }

//         const selectedProject = projects.find(
//             (p) => p.id === Number(formData.property_id)
//         );

//         const leadData = {
//             full_name: formData.full_name,
//             email: formData.email,
//             mobile_number: formData.mobile_number,

//             property_id: Number(formData.property_id),
//             property_title: selectedProject?.title || null,

//             handling_agent_id: Number(formData.handling_agent_id),

//             aadhaar_number: formData.aadharKyc || null,
//             status: "new",
//             state:formData.state,
//             city:formData.city,
//             investment_range:formData.investment_range,
//         };

//         if (editingAssociate) {
//             updateLead(editingAssociate.id, leadData);
//             alert("Lead updated successfully");
//         } else {
//             addLead(leadData);

//             //  fetchInvestorLead();
//             alert("Lead created successfully");
//         }

//         resetForm();
//     };


//     const resetForm = () => {
//         setFormData({
//             full_name: '',
//             email: '',
//             mobile_number: '',
//             property_id: '',
//             aadharKyc: null,
//             state:"",
//             city:"",
//             investment_range:''
//         });
//         setEditingAssociate(null);
//         setIsFormOpen(false);
//     };

//     // const handleEdit = (associate) => {

//     //     const project = projects.find(
//     //         (p) => p.project_name === associate.project_name
//     //     );
//     //     setEditingAssociate(associate);
//     //     setFormData({
//     //         full_name: associate.full_name,
//     //         email: associate.email,
//     //         mobile_number: associate.mobile_number,
//     //         // property_id: project ? project.id : "",
//     //         property_id: associate.property_id ? String(associate.property_id) : "",
//     //         handling_agent_id: associate.handling_agent_id
//     //             ? String(associate.handling_agent_id)
//     //             : "",
//     //         aadharKyc: associate.aadhar_no,
//     //     });
//     //     setIsFormOpen(true);
//     // };



//     const handleEdit = (associate) => {
//         setEditingAssociate(associate);

//         setFormData({
//             full_name: associate.full_name,
//             email: associate.email,
//             mobile_number: associate.mobile_number,
//             property_id: associate.property_id ? String(associate.property_id) : "",
//             handling_agent_id: associate.handling_agent_id
//                 ? String(associate.handling_agent_id)
//                 : "",
//             aadharKyc: associate.aadhaar_number || null,
//             state:associate.state,
//             city:associate.city,
//             investment_range:associate.investment_range,
//         });

//         setIsFormOpen(true);
//     };

//     const handleDelete = (id) => {
//         if (window.confirm('Are you sure you want to delete this associate?')) {
//             deleteAssociate(id);
//             alert('Associate deleted successfully');
//         }
//     };

//     const handleFileChange = (e) => {
//         const files = e.target.files;
//         if (files && files.length > 0) {
//             setFormData({ ...formData, aadharKyc: files[0] });
//         }
//     };
//     console.log('this is InvestorLeadss', InvestorLead)

//     const [leads, setLeads] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         axios
//             .get("https://api.propertygalleria.in/master/api/investorLeads") // adjust port if needed
//             .then((response) => {
//                 setLeads(response.data);
//                 setLoading(false);
//             })
//             .catch((err) => {
//                 setError(err.message);
//                 setLoading(false);
//             });
//     }, []);


//     //   const filteredAssociates = InvestorLead.filter(
//     //     (investor) =>
//     //       investor.full_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     //       investor.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     //       investor.mobile_number.includes(searchTerm)
//     //   );

//     const leadInvestorIds = leads.map(item => item.investor_id);

//     // const filteredAssociates = InvestorLead.filter((investor) => {
//     //     const search = searchTerm.toLowerCase();

//     //     return (
//     //         //   (investor.company_name ?? "").toLowerCase().includes(search) ||
//     //         (investor.full_name ?? "").toLowerCase().includes(search) ||
//     //         (investor.email ?? "").toLowerCase().includes(search) ||
//     //         (investor.mobile_number ?? "").includes(searchTerm)
//     //     );
//     // });


//     // const filteredAssociates = leads.filter((investor) => {
//     //     const search = searchTerm.toLowerCase();

//     //     const hasSameInvestorId = leadInvestorIds.includes(investor.investor_id);

//     //     const matchesSearch =
//     //         (investor.full_name ?? "").toLowerCase().includes(search) ||
//     //         (investor.email ?? "").toLowerCase().includes(search) ||
//     //         (investor.mobile_number ?? "").includes(searchTerm);

//     //     return hasSameInvestorId && matchesSearch;
//     // });

//     const filteredAssociates = leads
//         .filter((investor) => {
//             const search = searchTerm.toLowerCase();

//             return (
//                 (investor.full_name ?? "")
//                     .toLowerCase()
//                     .includes(search) ||
//                 (investor.email ?? "")
//                     .toLowerCase()
//                     .includes(search) ||
//                 (investor.mobile_number ?? "").includes(searchTerm)
//             );
//         })
//         .filter(
//             (value, index, self) =>
//                 index ===
//                 self.findIndex(
//                     (t) =>
//                         t.investor_id === value.investor_id &&
//                         t.property_title === value.property_title
//                 )
//         );


//     // console.log('this is leadssss',leads)
//     // console.log('this is leadInvestorIds',leadInvestorIds)
//     // console.log('this is filteredAssociates',filteredAssociates)

//     // console.log("InvestorLead length:", InvestorLead.length);
//     // console.log("Leads length:", leads.length);


//     const getProjectName = (property_id) => {
//         console.log('this is property_id', property_id)
//         console.log('this is projects', projects)
//         const id = Number(property_id); // convert string to number
//         const project = projects.find((p) => p.id === id);
//         return project ? project.title : property_id;
//     };
//     const getProjectName1 = (property_id) => {
//         const id = Number(property_id);
//         const project = projects.find((p) => p.id === id);
//         return project ? project.title : "Pending";
//     };


//     const getStatusLabel = (associate) => {
//         // If property not assigned
//         if (!associate.property_title) {
//             return "Pending";
//         }

//         // If property exists → show real status
//         return associate.status || "NEW";
//     };


//     // Inline Styles
//     const styles = {
//         container: { padding: '24px', fontFamily: 'Arial, sans-serif' },
//         header: { marginBottom: '24px' },
//         title: { fontSize: '24px', fontWeight: 'bold', color: '#0B1C3D', marginBottom: '4px' },
//         subtitle: { color: '#6B7280' },
//         actionsBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', gap: '16px' },
//         searchWrapper: { position: 'relative', flex: 1, maxWidth: '400px' },
//         searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' },
//         searchInput: { width: '100%', padding: '8px 16px 8px 36px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
//         addButton: { display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
//         formContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '24px', marginBottom: '24px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
//         formTitle: { fontSize: '20px', fontWeight: '600', marginBottom: '16px', color: '#0B1C3D' },
//         inputGroup: { marginBottom: '16px', display: 'flex', flexDirection: 'column' },
//         label: { fontSize: '14px', fontWeight: '500', marginBottom: '4px', color: '#374151', textAlign: 'left' },
//         required: { color: '#EF4444' },
//         input: { padding: '8px 12px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
//         buttonPrimary: { backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginRight: '8px' },
//         buttonSecondary: { backgroundColor: '#E5E7EB', color: '#374151', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
//         tableContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', overflowX: 'auto', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
//         table: { width: '100%', borderCollapse: 'collapse' },
//         th: { textAlign: 'left', padding: '12px', backgroundColor: '#8b306d', color: 'white', textAlign: 'center' },
//         td: { padding: '12px', color: '#374151', textAlign: 'center' },
//         badge: { display: 'inline-flex', alignItems: 'center', padding: '4px 8px', borderRadius: '999px', backgroundColor: '#42987e', color: '#fff', fontSize: '12px' },
//         actionButton: { padding: '4px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
//         stats: { marginTop: '16px', fontSize: '14px', color: '#6B7280', textAlign: 'right' },


//         pendingBadge: {
//             backgroundColor: "#FEF3C7", // light yellow
//             color: "#92400E",           // dark yellow
//         },

//         newBadge: {
//             backgroundColor: "#DCFCE7", // light green
//             color: "#166534",           // dark green
//         },
//     };


//     const [checkedUsers, setCheckedUsers] = useState([]);

//     const toggleCheckbox = (userId) => {
//         setCheckedUsers((prev) => {
//             if (prev.includes(userId)) {
//                 return prev.filter((id) => id !== userId);
//             } else {
//                 return [...prev, userId];
//             }
//         });
//     };

//     const handleSubmitApprove = async () => {
//         try {
//             // Approve all selected users
//             await Promise.all(
//                 checkedUsers.map((userId) =>
//                     axios.put(`https://api.propertygalleria.in/master/api/approve/${userId}`)
//                 )
//             );

//             alert("Selected users approved successfully!");


//             setCheckedUsers([]);
//             fetchAssociates();
//             // Optional: refresh list here
//         } catch (error) {
//             console.error(error);
//             alert("Approval failed. Please try again.");
//         }
//     };



//     // modal

//     const [isViewOpen, setIsViewOpen] = useState(false);
//     const [selectedAssociate, setSelectedAssociate] = useState(null);

//     // const openViewModal = (associate) => {
//     //     setSelectedAssociate(associate);
//     //     setIsViewOpen(true);
//     // };

//     // const closeViewModal = () => {
//     //     setIsViewOpen(false);
//     //     setSelectedAssociate(null);
//     // };

//     const getStatus = (property_title) => {
//         if (!property_title) return "Pending";
//         return "NEW";
//     };


//     // modal data 

//     const [properties, setProperties] = useState([]);
//     const [users, setUsers] = useState([]);
//     const [selectedProperty, setSelectedProperty] = useState(null);
//     const [selectedAgent, setSelectedAgent] = useState(null);

//     useEffect(() => {
//         fetch("https://api.propertygalleria.in/master/api/get/owner/properties")
//             .then(res => res.json())
//             .then(data => {
//                 if (data.success) setProperties(data.data);
//             });

//         fetch("https://api.propertygalleria.in/master/api/get/users")
//             .then(res => res.json())
//             .then(data => setUsers(data));
//     }, []);


//     const openViewModal = (associate) => {
//         console.log('this is associate', associate)
//         setSelectedAssociate(associate);

//         // Find property by property_id
//         const property = properties.find(
//             (p) => p.id === associate.property_id
//         );
//         setSelectedProperty(property || null);

//         // Find agent by handling_agent_id
//         const agent = users.find(
//             (u) => u.id === associate.handling_agent_id
//         );
//         setSelectedAgent(agent || null);

//         setIsViewOpen(true);
//     };

//     const closeViewModal = () => {
//         setIsViewOpen(false);
//         setSelectedAssociate(null);
//         setSelectedProperty(null);
//         setSelectedAgent(null);
//     };

//     const usersMap = Object.fromEntries(
//         users.map(user => [user.id, user.full_name])
//     );


//     //bulk upload

//     const [file, setFile] = useState(null);

//     const uploadFile = async () => {
//         if (!file) {
//             alert("Select Excel file");
//             return;
//         }

//         const formData = new FormData();
//         formData.append("documents", file);

//         try {
//             setLoading(true);

//             await axios.post(`${API_BASE}/bulk-upload`, formData, {
//                 headers: { "Content-Type": "multipart/form-data" },
//             });

//             alert("Bulk upload successful");
//             fetchInvestorLead();
//         } catch (err) {
//             alert("Upload failed");
//         } finally {
//             setLoading(false);
//         }
//     };


//     // pagenation

//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 10;

//     useEffect(() => {
//         setCurrentPage(1);
//     }, [searchTerm]);

//     const totalPages = Math.ceil(filteredAssociates.length / itemsPerPage);

//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const paginatedLeads = filteredAssociates.slice(
//         startIndex,
//         startIndex + itemsPerPage
//     );
//     const states = State.getStatesOfCountry("IN");

// console.log('this is paginatedLeads',paginatedLeads)

//     return (
//         <div style={styles.container}>
//             {/* Header */}
//             <div style={styles.header}>
//                 <h1 style={styles.title}>Investor Lead</h1>
//                 {/* <p style={styles.subtitle}>Manage InvestorLead and their project allocations</p> */}
//             </div>

//             {/* Actions Bar */}
//             <div style={styles.actionsBar}>
//                 <div style={styles.searchWrapper}>
//                     <Search size={20} style={styles.searchIcon} />
//                     <input
//                         type="text"
//                         placeholder="Search investor..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         style={styles.searchInput}
//                     />
//                 </div>
//                 <button style={styles.addButton} onClick={() => setIsFormOpen(true)}>
//                     <Plus size={20} /> Add Leads
//                 </button>
//             </div>

//             {/* Form */}
//             {isFormOpen && (
//                 <div style={styles.formContainer}>
//                     <h2 style={styles.formTitle}>{editingAssociate ? 'Edit Investor Lead' : 'Create New Investor Lead'}</h2>
//                     <form onSubmit={handleSubmit}>
//                         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '16px' }}>

//                             <div>
//                                 <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Project Allocation *</label>
//                                 <select
//                                     value={formData.property_id}
//                                     onChange={(e) => setFormData({ ...formData, property_id: e.target.value })}
//                                     style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
//                                     //required
//                                 >
//                                     <option value="">Select Property</option>
//                                     {projects.map((project) => (
//                                         <option key={project.id} value={project.id}>
//                                             {project.title} - {project.location}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>

//                             <div>
//                                 <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Agent Allocation *</label>
//                                 <select
//                                     value={formData.handling_agent_id}
//                                     onChange={(e) => setFormData({ ...formData, handling_agent_id: e.target.value })}
//                                     style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
//                                     // required
//                                 >
//                                     <option value="">Select Agent</option>
//                                     {/* {associates.map((agent) => (
//                                         <option key={agent.id} value={agent.id}>
//                                             {agent.full_name}
//                                         </option>
//                                     ))} */}

//                                     {users
//                                         .filter(u => u.role === "agent")
//                                         .map(agent => (
//                                             <option key={agent.id} value={agent.id}>
//                                                 {agent.full_name}
//                                             </option>
//                                         ))}
//                                 </select>
//                             </div>

//                             <div style={styles.inputGroup}>
//                                 <label style={styles.label}>
//                                     Name <span style={styles.required}>*</span>
//                                 </label>
//                                 <input
//                                     type="text"
//                                     value={formData.full_name}
//                                     onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
//                                     placeholder="e.g., Jane Smith"
//                                     style={styles.input}
//                                     required
//                                 />
//                             </div>

//                             <div style={styles.inputGroup}>
//                                 <label style={styles.label}>
//                                     Email <span style={styles.required}>*</span>
//                                 </label>
//                                 <input
//                                     type="email"
//                                     value={formData.email}
//                                     onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                                     placeholder="jane@example.com"
//                                     style={styles.input}
//                                     required
//                                 />
//                             </div>

//                             <div style={styles.inputGroup}>
//                                 <label style={styles.label}>
//                                     Mobile Number <span style={styles.required}>*</span>
//                                 </label>
//                                 <input
//                                     type="tel"
//                                     value={formData.mobile_number}
//                                     onChange={(e) => setFormData({ ...formData, mobile_number: e.target.value.replace(/\D/g, '').slice(0, 10) })}
//                                     placeholder="6309824545"
//                                     style={styles.input}
//                                     required
//                                 />
//                             </div>
//                             <div style={styles.inputGroup}>
//                                 <label style={styles.label}>State</label>
//                                 <select
//                                     style={styles.input}
//                                     value={formData.state}
//                                     onChange={(e) =>
//                                         setFormData({
//                                             ...formData,
//                                             state: e.target.value,
//                                             city: "" // reset city when state changes
//                                         })
//                                     }
//                                     required
//                                 >
//                                     <option value="">Select State</option>
//                                     {states.map((state) => (
//                                         <option key={state.isoCode} value={state.isoCode}>
//                                             {state.name}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                             <div style={styles.inputGroup}>
//                                 <label style={styles.label}>City</label>
//                                 <select
//                                     style={styles.input}
//                                     value={formData.city}
//                                     onChange={(e) =>
//                                         setFormData({ ...formData, city: e.target.value })
//                                     }
//                                     required
//                                     disabled={!formData.state}
//                                 >
//                                     <option value="">Select City</option>
//                                     {City.getCitiesOfState("IN", formData.state).map((city) => (
//                                         <option key={city.name} value={city.name}>
//                                             {city.name}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>



//                             <div>
//                                 <label style={styles.label}>Investment Range</label>
//                                 <select
//                                     value={formData.investment_range}
//                                     onChange={(e) => setFormData({ ...formData, investment_range: e.target.value })}
//                                    style={styles.input}
//                                 >

//                                     <option value="Select Investment Range">Select Investment Range</option>
//                                     <option value="10-15 Lakhs">10-15 Lakhs</option>
//                                     <option value="25-35 Lakhs">25-35 Lakhs</option>
//                                     <option value="45-55 Lakhs">45-55 Lakhs</option>
//                                     <option value="65-75 Lakhs">65-75 Lakhs</option>
//                                     <option value="85-95 Lakhs">85-95 Lakhs</option>
//                                     <option value="1Cr">1 Crore</option>
//                                     <option value="1Cr-2Cr">1-2 Crore</option>
//                                     <option value="3Cr-4Cr">3-4 Crore</option>
//                                 </select>
//                             </div>

//                             {/* <div style={styles.inputGroup}>
//                                 <label style={styles.label}>
//                                     Years of Experience <span style={styles.required}>*</span>
//                                 </label>
//                                 <input
//                                     type="number"
//                                     value={formData.experience_years}
//                                     onChange={(e) => setFormData({ ...formData, experience_years: e.target.value })}
//                                     placeholder="Enter you Experience"
//                                     style={styles.input}
//                                     required
//                                 />
//                             </div> */}



//                             {/* <div style={styles.inputGroup}>
//                                 <label style={styles.label}>
//                                     Aadhaar Number <span style={styles.required}>*</span>
//                                 </label>
//                                 <input
//                                     type="text"
//                                     value={formData.aadharKyc}
//                                     onChange={(e) =>
//                                         setFormData({
//                                             ...formData,
//                                             aadharKyc: e.target.value.replace(/\D/g, "").slice(0, 12),
//                                         })
//                                     }
//                                     placeholder="Enter 12-digit Aadhaar"
//                                     style={styles.input}
//                                     maxLength={12}
//                                 />
//                             </div> */}
//                             {/* <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//                                 <button
//                                     type="button"
//                                     onClick={sendAadharOtp}
//                                     disabled={loadingOtp || otpSent}
//                                     style={styles.buttonSecondary}
//                                 >
//                                     {loadingOtp ? "Sending..." : otpSent ? "OTP Sent" : "Send OTP"}
//                                 </button>

//                                 {aadharVerified && (
//                                     <span style={{ ...styles.badge, backgroundColor: "#16A34A" }}>
//                                         Verified
//                                     </span>
//                                 )}
//                             </div> */}

//                             {/* {otpSent && !aadharVerified && (
//                                 <div style={{ marginTop: 8 }}>
//                                     <input
//                                         type="text"
//                                         value={otp}
//                                         onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
//                                         placeholder="Enter OTP"
//                                         style={styles.input}
//                                     />
//                                     <button
//                                         type="button"
//                                         onClick={verifyAadharOtp}
//                                         style={{ ...styles.buttonPrimary, marginTop: 8 }}
//                                     >
//                                         Verify OTP
//                                     </button>
//                                 </div>
//                             )} */}

//                         </div>

//                         <div style={{ display: 'flex', gap: '12px' }}>
//                             <button type="submit" style={styles.buttonPrimary}>
//                                 {editingAssociate ? 'Update Associate' : 'Create Associate'}
//                             </button>


//                             <input
//                                 type="file"
//                                 accept=".xlsx,.xls"
//                                 onChange={(e) => setFile(e.target.files[0])}
//                                 style={styles.input}
//                             />

//                             <button type="button" onClick={uploadFile} style={styles.buttonSecondary}>
//                                 {loading ? "Uploading Bulk Leads..." : "Upload Bulk Leads"}
//                             </button>
//                         </div>

//                         <div style={{ display: "flex", gap: "12px", margin: '5px' }}>
//                             <button type="button" onClick={resetForm} style={styles.buttonSecondary}>
//                                 Cancel
//                             </button>
//                         </div>


//                     </form>
//                 </div>
//             )}

//             {/* Associates Table */}
//             <div style={styles.tableContainer}>
//                 <table style={styles.table}>
//                     <thead>
//                         <tr>
//                             <th style={styles.th}>Name</th>
//                             <th style={styles.th}>Email</th>
//                             <th style={styles.th}>Mobile</th>
//                             <th style={styles.th}>Property </th>
//                             <th style={styles.th}>Associate</th>
//                             <th style={styles.th}>status</th>
//                             {/* <th style={styles.th}>Aadhar KYC</th> */}
//                             <th style={styles.th}>Actions</th>
//                             {/* <th style={styles.th}>Approve </th> */}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {paginatedLeads.length === 0 ? (
//                             <tr>
//                                 <td colSpan={6} style={{ ...styles.td, textAlign: 'center', padding: '32px', color: '#9CA3AF' }}>
//                                     {searchTerm
//                                         ? 'No InvestorLead found matching your search'
//                                         : 'No InvestorLead created yet. Click "Add Associate" to get started.'}
//                                 </td>
//                             </tr>
//                         ) : (
//                             paginatedLeads.map((associate, index) => (
//                                 <tr
//                                     //key={associate.user_id}
//                                     key={`${associate.user_id}-${associate.investor_id}-${associate.property_id}`}

//                                     style={{
//                                         backgroundColor: index % 2 === 0 ? 'white' : '#F9FAFB',
//                                         transition: 'background-color 0.2s',
//                                     }}
//                                 >
//                                     <td style={styles.td}>{associate.full_name}</td>
//                                     <td style={styles.td}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//                                             <Mail size={16} color="#9CA3AF" />
//                                             {associate.email}
//                                         </div>
//                                     </td>
//                                     <td style={styles.td}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//                                             <Phone size={16} color="#9CA3AF" />
//                                             {associate.mobile_number}
//                                         </div>
//                                     </td>
//                                     <td style={styles.td}>
//                                         {/* <span style={styles.badge}>{getProjectName(associate.property_title)}</span> */}
//                                         {/* <span style={styles.badge}>
//                                             {associate.property_title
//                                                 ? getProjectName(associate.property_title)
//                                                 : "Pending"}
//                                         </span> */}


//                                         <span
//                                             style={{
//                                                 ...styles.badge,
//                                                 ...(associate.property_title
//                                                     ? styles.newBadge
//                                                     : styles.pendingBadge),
//                                             }}
//                                         >
//                                             {associate.property_title
//                                                 ? getProjectName(associate.property_title)
//                                                 : "Pending" || "General Inquiry"}
//                                         </span>


//                                     </td>
//                                     {/* <td style={styles.td}>
//                                         {associate.handling_agent_id}
//                                     </td> */}
//                                     <td style={styles.td}>
//                                         <span style={{
//                                             ...styles.badge,
//                                             ...styles.newBadge
//                                         }}>
//                                             {usersMap[associate.handling_agent_id] || "Not Assign the Associate"}
//                                         </span>
//                                     </td>


//                                     <td style={styles.td}>
//                                         {/* <span style={styles.badge}>{getProjectName(associate.status)}</span> */}
//                                         {/* <span style={styles.badge}>
//                                             {getStatusLabel(associate)}
//                                         </span> */}
//                                         {/*                                        
//                                             <span
//                                                 style={{
//                                                     ...styles.badge,
//                                                     ...(getStatusLabel(associate) === "Pending"
//                                                         ? styles.pendingBadge
//                                                         : styles.newBadge),
//                                                 }}
//                                             >
//                                                 {getStatusLabel(associate)}
//                                             </span> */}

//                                         <span
//                                             style={{
//                                                 ...styles.badge,
//                                                 ...(getStatusLabel(associate) === "Pending"
//                                                     ? styles.pendingBadge
//                                                     : styles.newBadge),
//                                             }}
//                                         >
//                                             {getStatusLabel(associate)}
//                                         </span>


//                                     </td>
//                                     {/* <td style={styles.td}> status
//                     {associate.aadhaar_number ? associate.aadhaar_number : <span style={{ color: '#9CA3AF', fontSize: '12px' }}>N/A</span>}
//                   </td> */}
//                                     <td style={styles.td}>
//                                         <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>

//                                             {/* <button  style={{ ...styles.actionButton, color: '#8b306d' }} title="View">
//                         <Eye size={18} />
//                       </button> */}
//                                             <button
//                                                 onClick={() => openViewModal(associate)}
//                                                 style={{ ...styles.actionButton, color: '#8b306d' }}
//                                                 title="View"
//                                             >
//                                                 <Eye size={18} />
//                                             </button>

//                                             <button onClick={() => handleEdit(associate)} style={{ ...styles.actionButton, color: '#42987e' }} title="Edit">
//                                                 <Pencil size={18} />
//                                             </button>
//                                             <button onClick={() => handleDelete(associate.user_id)} style={{ ...styles.actionButton, color: '#ff9d00ff' }} title="Delete">
//                                                 <Trash size={18} />
//                                             </button>
//                                         </div>
//                                     </td>
//                                     {/* <td style={styles.td}>{associate.is_admin_approve}</td> */}
//                                     {/* <td style={styles.td}>
//                     <input
//                       type="checkbox"
//                       checked={
//                         associate.is_admin_approve === 1
//                           ? true
//                           : checkedUsers.includes(associate.user_id)
//                       }
//                      // disabled={associate.is_admin_approve === 1}
//                       onChange={() => toggleCheckbox(associate.user_id)}
//                     />
//                   </td> */}

//                                 </tr>
//                             ))
//                         )}
//                     </tbody>
//                 </table>

//                 {/* ✅ Show Submit Button only if at least 1 checked */}
//                 {checkedUsers.length > 0 && (
//                     <div style={{ marginTop: "16px", textAlign: "right" }}>
//                         <button onClick={handleSubmitApprove} style={styles.submitButton}>
//                             Approve the User
//                         </button>
//                     </div>
//                 )}
//             </div>

//             <Modal
//                 isOpen={isViewOpen}
//                 onRequestClose={closeViewModal}
//                 style={{
//                     content: {
//                         width: "80%",
//                         maxWidth: "900px",
//                         margin: "auto",
//                         borderRadius: "12px",
//                         padding: "24px",
//                     },
//                     overlay: {
//                         backgroundColor: "rgba(0,0,0,0.4)",
//                     },
//                 }}
//             >
//                 <h2 style={{ marginBottom: "16px" }}>Investor Details</h2>

//                 {/* 🔹 Property Details Table */}
//                 <h4 style={{ marginBottom: "8px" }}>Property Details</h4>
//                 <table style={styles.table}>
//                     <thead>
//                         <tr>
//                             <th style={styles.th}>Zone </th>
//                             <th style={styles.th}>Property Title</th>
//                             <th style={styles.th}>Location</th>
//                             <th style={styles.th}>Type</th>
//                             <th style={styles.th}>Status</th>
//                         </tr>
//                     </thead>
//                     {/* <tbody>
//                         <tr>
//                             <td style={styles.td}>
//                                 {selectedAssociate?.property_title || "N/A"}
//                             </td>
//                             <td style={styles.td}>Hyderabad</td>
//                             <td style={styles.td}>Residential</td>
//                             <td style={styles.td}>
//                                 <span style={styles.badge}>
//                                     {getStatus(selectedAssociate?.property_title)}
//                                 </span>
//                             </td>
//                         </tr>
//                     </tbody> */}

//                     <tbody>
//                         {selectedProperty ? (
//                             <tr>
//                                 <td style={styles.td}>{selectedProperty.zone_desc}</td>
//                                 <td style={styles.td}>{selectedProperty.title}</td>
//                                 <td style={styles.td}>{selectedProperty.location}</td>
//                                 <td style={styles.td}>{selectedProperty.category}</td>
//                                 <td style={styles.td}>
//                                     <span style={{ ...styles.badge, ...styles.newBadge }}>
//                                         Active
//                                     </span>
//                                 </td>
//                             </tr>
//                         ) : (
//                             <tr>
//                                 <td colSpan={4} style={{ ...styles.td, textAlign: "center" }}>
//                                     No Property Assigned
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>

//                 </table>

//                 {/* 🔹 Agent Details Table */}
//                 <h4 style={{ margin: "24px 0 8px" }}>Agent Details</h4>
//                 <table style={styles.table}>
//                     <thead>
//                         <tr>
//                             <th style={styles.th}>Name</th>
//                             <th style={styles.th}>Email</th>
//                             <th style={styles.th}>Mobile</th>
//                             <th style={styles.th}>Status</th>
//                         </tr>
//                     </thead>
//                     {/* <tbody>
//                         <tr>
//                             <td style={styles.td}>{selectedAssociate?.full_name}</td>
//                             <td style={styles.td}>{selectedAssociate?.email}</td>
//                             <td style={styles.td}>{selectedAssociate?.mobile_number}</td>
//                             <td style={styles.td}>
//                                 <span style={styles.badge}>
//                                     {getStatus(selectedAssociate?.property_title)}
//                                 </span>
//                             </td>
//                         </tr>
//                     </tbody> */}

//                     <tbody>
//                         {selectedAgent ? (
//                             <tr>
//                                 <td style={styles.td}>{selectedAgent.full_name}</td>
//                                 <td style={styles.td}>{selectedAgent.email}</td>
//                                 <td style={styles.td}>{selectedAgent.mobile_number}</td>
//                                 <td style={styles.td}>
//                                     <span style={{ ...styles.badge, ...styles.newBadge }}>
//                                         Active
//                                     </span>
//                                 </td>
//                             </tr>
//                         ) : (
//                             <tr>
//                                 <td colSpan={4} style={{ ...styles.td, textAlign: "center" }}>
//                                     No Agent Assigned
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>

//                 </table>

//                 {/* 🔹 Footer */}
//                 <div style={{ marginTop: "24px", textAlign: "right" }}>
//                     <button onClick={closeViewModal} style={styles.submitButton}>
//                         Close
//                     </button>
//                 </div>
//             </Modal>


//             {/* Stats */}
//             <div style={styles.stats}>
//                 Total Associates: {filteredAssociates.length}
//                 {searchTerm && ` (filtered from ${InvestorLead.length})`}
//             </div>

//             <div
//                 style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     padding: "12px 16px",
//                     borderTop: "1px solid #E5E7EB",
//                     background: "#F9FAFB",
//                 }}
//             >
//                 <div style={{ fontSize: 14, color: "#6B7280" }}>
//                     Showing {startIndex + 1}–
//                     {Math.min(startIndex + itemsPerPage, filteredAssociates.length)} of{" "}
//                     {filteredAssociates.length}
//                 </div>

//                 <div style={{ display: "flex", gap: "6px" }}>
//                     <button
//                         disabled={currentPage === 1}
//                         onClick={() => setCurrentPage((p) => p - 1)}
//                         style={{
//                             padding: "6px 12px",
//                             borderRadius: "6px",
//                             border: "1px solid #ddd",
//                             background: currentPage === 1 ? "#eee" : "#fff",
//                             cursor: "pointer",
//                         }}
//                     >
//                         Prev
//                     </button>

//                     {Array.from({ length: totalPages }, (_, i) => i + 1)
//                         .slice(
//                             Math.max(0, currentPage - 3),
//                             Math.min(totalPages, currentPage + 2)
//                         )
//                         .map((page) => (
//                             <button
//                                 key={page}
//                                 onClick={() => setCurrentPage(page)}
//                                 style={{
//                                     padding: "6px 12px",
//                                     borderRadius: "6px",
//                                     border: "1px solid #ddd",
//                                     background:
//                                         currentPage === page ? "#8b306d" : "#fff",
//                                     color: currentPage === page ? "#fff" : "#333",
//                                     cursor: "pointer",
//                                 }}
//                             >
//                                 {page}
//                             </button>
//                         ))}

//                     <button
//                         disabled={currentPage === totalPages}
//                         onClick={() => setCurrentPage((p) => p + 1)}
//                         style={{
//                             padding: "6px 12px",
//                             borderRadius: "6px",
//                             border: "1px solid #ddd",
//                             background:
//                                 currentPage === totalPages ? "#eee" : "#fff",
//                             cursor: "pointer",
//                         }}
//                     >
//                         Next
//                     </button>
//                 </div>
//             </div>

//         </div>
//     );
// };






import React, { useEffect, useState } from 'react';
import { Pencil, Trash, Plus, Search, Mail, Phone, FileText, Eye } from 'lucide-react';
import { useAdmin } from '../AdminLayout/AdminProvider';
import axios from 'axios';
import { ArrowLeft, User, Clock, RefreshCcw } from "lucide-react";
import { State, City } from "country-state-city";
import Modal from "react-modal";
Modal.setAppElement("#root");


const API_BASE = "https://api.propertygalleria.in/master/api";
const API_BASEE = "http://localhost:4001";

export const InvestorLead = () => {
    const { associates, InvestorLead, projects, addAssociate, updateAssociate, deleteAssociate, fetchAssociates, fetchInvestorLead } = useAdmin();
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [editingAssociate, setEditingAssociate] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    const [aadharVerified, setAadharVerified] = useState(false);
    const [loadingOtp, setLoadingOtp] = useState(false);

    console.log('this InvestorLeads', InvestorLead)

    const [formData, setFormData] = useState({
        full_name: '',
        email: '',
        mobile_number: '',
        property_id: '',
        handling_agent_id: '',
        aadharKyc: null,
        experience_years: '',
        state: "",
        city: "",
        investment_range: ""
    });


    const sendAadharOtp = async () => {
        if (formData.aadharKyc.length !== 12) {
            alert("Enter valid 12-digit Aadhaar number");
            return;
        }

        try {
            setLoadingOtp(true);
            await axios.post(`${API_BASE}/api/send-aadhar-otp`, {
                Aadhar_No: formData.aadharKyc,
            });
            setOtpSent(true);
            alert("OTP sent successfully");
        } catch (err) {
            alert("Failed to send OTP");
        } finally {
            setLoadingOtp(false);
        }
    };



    const verifyAadharOtp = async () => {
        if (!otp) {
            alert("Enter OTP");
            return;
        }

        try {
            await axios.post(`${API_BASE}/api/verify-aadhar-otp`, {
                otp,
                Aadhar_No: formData.aadharKyc,
            });

            setAadharVerified(true);
            alert("Aadhaar verified successfully");
        } catch (err) {
            alert("OTP verification failed");
        }
    };


    // ✅ CREATE LEAD
    const addLead = async (leadData) => {
        console.log('this is leadData', leadData)
        try {
            await axios.post(`${API_BASE}/api/leads`, {
                name: leadData.full_name,
                email: leadData.email,
                mobile: leadData.mobile_number,
                aadhar: leadData.aadhaar_number || null,
                property_id: leadData.property_id || null,
                property_title: leadData.property_title || null,
                handling_agent_id: leadData.handling_agent_id || null,
                investmentRange: leadData.investment_range || null,
                location: null,
                remarks: null,
                status: "new",
                state: leadData.state,
                city: leadData.city
            });

            fetchInvestorLead();
        } catch (err) {
            console.error(err);
            alert("Failed to create lead");
        }
    };


    // ✅ UPDATE LEAD
    const updateLead = async (leadId, leadData) => {

        console.log('this is leadID', leadId)
        console.log('this is leadData', leadData)
        try {
            await axios.put(`${API_BASE}/api/leads/${leadId}`, {
                status: leadData.status || "new",
                remarks: leadData.remarks || null,
                investmentRange: null,
                location: null,
                property_id: leadData.property_id || null,
                property_title: leadData.property_title || null,
                handling_agent_id: leadData.handling_agent_id || null,
            });

            fetchInvestorLead();
        } catch (err) {
            console.error(err);
            alert("Failed to update lead");
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.full_name || !formData.mobile_number) {
            alert("Name and Mobile are required");
            return;
        }

        const selectedProject = projects.find(
            (p) => p.id === Number(formData.property_id)
        );

        const leadData = {
            full_name: formData.full_name,
            email: formData.email,
            mobile_number: formData.mobile_number,

            property_id: Number(formData.property_id),
            property_title: selectedProject?.title || null,

            handling_agent_id: Number(formData.handling_agent_id),

            aadhaar_number: formData.aadharKyc || null,
            status: "new",
            state: formData.state,
            city: formData.city,
            investment_range: formData.investment_range,
        };

        if (editingAssociate) {
            updateLead(editingAssociate.id, leadData);
            alert("Lead updated successfully");
        } else {
            addLead(leadData);

            //  fetchInvestorLead();
            alert("Lead created successfully");
        }

        resetForm();
    };


    const resetForm = () => {
        setFormData({
            full_name: '',
            email: '',
            mobile_number: '',
            property_id: '',
            aadharKyc: null,
            state: "",
            city: "",
            investment_range: ''
        });
        setEditingAssociate(null);
        setIsFormOpen(false);
    };
    const handleEdit = (associate) => {
        setEditingAssociate(associate);

        setFormData({
            full_name: associate.full_name,
            email: associate.email,
            mobile_number: associate.mobile_number,
            property_id: associate.property_id ? String(associate.property_id) : "",
            handling_agent_id: associate.handling_agent_id
                ? String(associate.handling_agent_id)
                : "",
            aadharKyc: associate.aadhaar_number || null,
            state: associate.state,
            city: associate.city,
            investment_range: associate.investment_range,
        });

        setIsFormOpen(true);
    };

    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this associate?')) {
            deleteAssociate(id);
            alert('Associate deleted successfully');
        }
    };

    const handleFileChange = (e) => {
        const files = e.target.files;
        if (files && files.length > 0) {
            setFormData({ ...formData, aadharKyc: files[0] });
        }
    };
    console.log('this is InvestorLeadss', InvestorLead)

    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios
            .get("https://api.propertygalleria.in/master/api/investorLeads") // adjust port if needed
            .then((response) => {
                setLeads(response.data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    const leadInvestorIds = leads.map(item => item.investor_id);
    const filteredAssociates = leads
        .filter((investor) => {
            const search = searchTerm.toLowerCase();

            return (
                (investor.full_name ?? "")
                    .toLowerCase()
                    .includes(search) ||
                (investor.email ?? "")
                    .toLowerCase()
                    .includes(search) ||
                (investor.mobile_number ?? "").includes(searchTerm)
            );
        })
        // .filter(
        //     (value, index, self) =>
        //         index ===
        //         self.findIndex(
        //             (t) =>
        //                 t.investor_id === value.investor_id &&
        //                 t.property_title === value.property_title
        //         )
        // );
        .filter(
            (value, index, self) =>
                index === self.findIndex(
                    (t) => t.investor_id === value.investor_id
                )
        );


    const getProjectName = (property_id) => {
        console.log('this is property_id', property_id)
        console.log('this is projects', projects)
        const id = Number(property_id); // convert string to number
        const project = projects.find((p) => p.id === id);
        return project ? project.title : property_id;
    };
    const getProjectName1 = (property_id) => {
        const id = Number(property_id);
        const project = projects.find((p) => p.id === id);
        return project ? project.title : "Pending";
    };


    const getStatusLabel = (associate) => {
        // If property not assigned
        if (!associate.property_title) {
            return "Pending";
        }

        // If property exists → show real status
        return associate.status || "NEW";
    };


    // Inline Styles
    const styles = {
        container: { padding: '24px', fontFamily: 'Arial, sans-serif' },
        header: { marginBottom: '24px' },
        title: { fontSize: '24px', fontWeight: 'bold', color: '#0B1C3D', marginBottom: '4px' },
        subtitle: { color: '#6B7280' },
        actionsBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', gap: '16px' },
        searchWrapper: { position: 'relative', flex: 1, maxWidth: '400px' },
        searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' },
        searchInput: { width: '100%', padding: '8px 16px 8px 36px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
        addButton: { display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
        formContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '24px', marginBottom: '24px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
        formTitle: { fontSize: '20px', fontWeight: '600', marginBottom: '16px', color: '#0B1C3D' },
        inputGroup: { marginBottom: '16px', display: 'flex', flexDirection: 'column' },
        label: { fontSize: '14px', fontWeight: '500', marginBottom: '4px', color: '#374151', textAlign: 'left' },
        required: { color: '#EF4444' },
        input: { padding: '8px 12px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
        buttonPrimary: { backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginRight: '8px' },
        buttonSecondary: { backgroundColor: '#E5E7EB', color: '#374151', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
        tableContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', overflowX: 'auto', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
        table: { width: '100%', borderCollapse: 'collapse' },
        th: { textAlign: 'left', padding: '12px', backgroundColor: '#8b306d', color: 'white', textAlign: 'center' },
        td: { padding: '12px', color: '#374151', textAlign: 'center' },
        badge: { display: 'inline-flex', alignItems: 'center', padding: '4px 8px', borderRadius: '999px', backgroundColor: '#42987e', color: '#fff', fontSize: '12px' },
        actionButton: { padding: '4px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
        stats: { marginTop: '16px', fontSize: '14px', color: '#6B7280', textAlign: 'right' },


        pendingBadge: {
            backgroundColor: "#FEF3C7", // light yellow
            color: "#92400E",           // dark yellow
        },

        newBadge: {
            backgroundColor: "#DCFCE7", // light green
            color: "#166534",           // dark green
        },
    };


    const [checkedUsers, setCheckedUsers] = useState([]);

    const toggleCheckbox = (userId) => {
        setCheckedUsers((prev) => {
            if (prev.includes(userId)) {
                return prev.filter((id) => id !== userId);
            } else {
                return [...prev, userId];
            }
        });
    };

    const handleSubmitApprove = async () => {
        try {
            // Approve all selected users
            await Promise.all(
                checkedUsers.map((userId) =>
                    axios.put(`https://api.propertygalleria.in/master/api/approve/${userId}`)
                )
            );

            alert("Selected users approved successfully!");


            setCheckedUsers([]);
            fetchAssociates();
            // Optional: refresh list here
        } catch (error) {
            console.error(error);
            alert("Approval failed. Please try again.");
        }
    };



    // modal

    const [isViewOpen, setIsViewOpen] = useState(false);
    const [selectedAssociate, setSelectedAssociate] = useState(null);

    const getStatus = (property_title) => {
        if (!property_title) return "Pending";
        return "NEW";
    };


    // modal data 

    const [properties, setProperties] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState(null);


    // const [selectedAgent, setSelectedAgent] = useState(null);
    const [selectedAgent, setSelectedAgent] = useState([]);

    const [selectedInvestorLeads, setSelectedInvestorLeads] = useState([]);

    useEffect(() => {
        fetch("https://api.propertygalleria.in/master/api/get/owner/properties")
            .then(res => res.json())
            .then(data => {
                if (data.success) setProperties(data.data);
            });

        fetch("https://api.propertygalleria.in/master/api/get/users")
            .then(res => res.json())
            .then(data => setUsers(data));
    }, []);


    const openViewModal1 = (associate) => {
        console.log('this is associate', associate)
        setSelectedAssociate(associate);

        // Find property by property_id
        const property = properties.find(
            (p) => p.id === associate.property_id
        );
        setSelectedProperty(property || null);

        // Find agent by handling_agent_id
        const agent = users.find(
            (u) => u.id === associate.handling_agent_id
        );
        setSelectedAgent(agent || null);

        setIsViewOpen(true);
    };

    const openViewModal2 = (associate) => {
        setSelectedAssociate(associate);

        const investorLeads = leads.filter(
            (l) => l.investor_id === associate.investor_id
        );

        setSelectedInvestorLeads(investorLeads);
        setIsViewOpen(true);
    };

    const openViewModal = (associate) => {
        setSelectedAssociate(associate);

        // all properties of investor
        const investorLeads = leads.filter(
            (l) => l.investor_id === associate.investor_id
        );

        setSelectedInvestorLeads(investorLeads);

        // collect agents
        const agentIds = [
            ...new Set(
                investorLeads
                    .map(l => l.handling_agent_id)
                    .filter(Boolean)
            )
        ];

        const agents = users.filter(u =>
            agentIds.includes(u.id)
        );

        setSelectedAgent(agents);

        setIsViewOpen(true);
    };

    const closeViewModal1 = () => {
        setIsViewOpen(false);
        setSelectedAssociate(null);
        setSelectedProperty(null);
        setSelectedAgent(null);
    };
    const closeViewModal2 = () => {
        setIsViewOpen(false);
        setSelectedAssociate(null);
        setSelectedInvestorLeads([]);
    };
    const closeViewModal = () => {
        setIsViewOpen(false);
        setSelectedAssociate(null);
        setSelectedInvestorLeads([]);
        setSelectedAgent([]);
    };

    const usersMap = Object.fromEntries(
        users.map(user => [user.id, user.full_name])
    );


    //bulk upload

    const [file, setFile] = useState(null);

    const uploadFile = async () => {
        if (!file) {
            alert("Select Excel file");
            return;
        }

        const formData = new FormData();
        formData.append("documents", file);

        try {
            setLoading(true);

            await axios.post(`${API_BASE}/bulk-upload`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            alert("Bulk upload successful");
            fetchInvestorLead();
        } catch (err) {
            alert("Upload failed");
        } finally {
            setLoading(false);
        }
    };


    // pagenation

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const totalPages = Math.ceil(filteredAssociates.length / itemsPerPage);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedLeads = filteredAssociates.slice(
        startIndex,
        startIndex + itemsPerPage
    );
    const states = State.getStatesOfCountry("IN");

    console.log('this is paginatedLeads', paginatedLeads)
    console.log('this is selectedInvestorLeads', selectedInvestorLeads)
    console.log('this is selectedAgent', selectedAgent)


    // this is for history leads

    const [showHistory, setShowHistory] = useState(false);
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [history, setHistory] = useState([]);
    const [loadingHistory, setLoadingHistory] = useState(false);

    const openHistory = async (leadId) => {
        setSelectedLeadId(leadId);
        setShowHistory(true);
        setLoadingHistory(true);

        try {
            const res = await fetch(
                `https://api.propertygalleria.in/master/api/api/leads/${leadId}/history`
            );

            const json = await res.json();

            if (json.success) {
                setHistory(json.data);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoadingHistory(false);
        }
    };

    return (
        <div style={styles.container}>
            {/* Header */}
            <div style={styles.header}>
                <h1 style={styles.title}>Investor Lead</h1>
                {/* <p style={styles.subtitle}>Manage InvestorLead and their project allocations</p> */}
            </div>

            {/* Actions Bar */}
            <div style={styles.actionsBar}>
                <div style={styles.searchWrapper}>
                    <Search size={20} style={styles.searchIcon} />
                    <input
                        type="text"
                        placeholder="Search investor..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={styles.searchInput}
                    />
                </div>
                <button style={styles.addButton} onClick={() => setIsFormOpen(true)}>
                    <Plus size={20} /> Add Leads
                </button>
            </div>

            {/* Form */}
            {isFormOpen && (
                <div style={styles.formContainer}>
                    <h2 style={styles.formTitle}>{editingAssociate ? 'Edit Investor Lead' : 'Create New Investor Lead'}</h2>
                    <form onSubmit={handleSubmit}>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '16px' }}>

                            <div>
                                <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Project Allocation *</label>
                                <select
                                    value={formData.property_id}
                                    onChange={(e) => setFormData({ ...formData, property_id: e.target.value })}
                                    style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
                                //required
                                >
                                    <option value="">Select Property</option>
                                    {projects.map((project) => (
                                        <option key={project.id} value={project.id}>
                                            {project.title} - {project.location}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Agent Allocation *</label>
                                <select
                                    value={formData.handling_agent_id}
                                    onChange={(e) => setFormData({ ...formData, handling_agent_id: e.target.value })}
                                    style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
                                // required
                                >
                                    <option value="">Select Agent</option>
                                    {users
                                        .filter(u => u.role === "agent")
                                        .map(agent => (
                                            <option key={agent.id} value={agent.id}>
                                                {agent.full_name}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>
                                    Name <span style={styles.required}>*</span>
                                </label>
                                <input
                                    type="text"
                                    value={formData.full_name}
                                    onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
                                    placeholder="e.g., Jane Smith"
                                    style={styles.input}
                                    required
                                />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>
                                    Email <span style={styles.required}>*</span>
                                </label>
                                <input
                                    type="email"
                                    value={formData.email}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    placeholder="jane@example.com"
                                    style={styles.input}
                                    required
                                />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>
                                    Mobile Number <span style={styles.required}>*</span>
                                </label>
                                <input
                                    type="tel"
                                    value={formData.mobile_number}
                                    onChange={(e) => setFormData({ ...formData, mobile_number: e.target.value.replace(/\D/g, '').slice(0, 10) })}
                                    placeholder="6309824545"
                                    style={styles.input}
                                    required
                                />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>State</label>
                                <select
                                    style={styles.input}
                                    value={formData.state}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            state: e.target.value,
                                            city: "" // reset city when state changes
                                        })
                                    }
                                    required
                                >
                                    <option value="">Select State</option>
                                    {states.map((state) => (
                                        <option key={state.isoCode} value={state.isoCode}>
                                            {state.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>City</label>
                                <select
                                    style={styles.input}
                                    value={formData.city}
                                    onChange={(e) =>
                                        setFormData({ ...formData, city: e.target.value })
                                    }
                                    required
                                    disabled={!formData.state}
                                >
                                    <option value="">Select City</option>
                                    {City.getCitiesOfState("IN", formData.state).map((city) => (
                                        <option key={city.name} value={city.name}>
                                            {city.name}
                                        </option>
                                    ))}
                                </select>
                            </div>



                            <div>
                                <label style={styles.label}>Investment Range</label>
                                <select
                                    value={formData.investment_range}
                                    onChange={(e) => setFormData({ ...formData, investment_range: e.target.value })}
                                    style={styles.input}
                                >

                                    <option value="Select Investment Range">Select Investment Range</option>
                                    <option value="10-15 Lakhs">10-15 Lakhs</option>
                                    <option value="25-35 Lakhs">25-35 Lakhs</option>
                                    <option value="45-55 Lakhs">45-55 Lakhs</option>
                                    <option value="65-75 Lakhs">65-75 Lakhs</option>
                                    <option value="85-95 Lakhs">85-95 Lakhs</option>
                                    <option value="1Cr">1 Crore</option>
                                    <option value="1Cr-2Cr">1-2 Crore</option>
                                    <option value="3Cr-4Cr">3-4 Crore</option>
                                </select>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '12px' }}>
                            <button type="submit" style={styles.buttonPrimary}>
                                {editingAssociate ? 'Update Associate' : 'Create Associate'}
                            </button>


                            <input
                                type="file"
                                accept=".xlsx,.xls"
                                onChange={(e) => setFile(e.target.files[0])}
                                style={styles.input}
                            />

                            <button type="button" onClick={uploadFile} style={styles.buttonSecondary}>
                                {loading ? "Uploading Bulk Leads..." : "Upload Bulk Leads"}
                            </button>
                        </div>

                        <div style={{ display: "flex", gap: "12px", margin: '5px' }}>
                            <button type="button" onClick={resetForm} style={styles.buttonSecondary}>
                                Cancel
                            </button>
                        </div>


                    </form>
                </div>
            )}

            {/* Associates Table */}
            <div style={styles.tableContainer}>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.th}>Name</th>
                            <th style={styles.th}>Email</th>
                            <th style={styles.th}>Mobile</th>
                            {/* <th style={styles.th}>Property </th>
                            <th style={styles.th}>Associate</th> */}
                            <th style={styles.th}>status</th>
                            <th style={styles.th}>Actions</th>


                        </tr>
                    </thead>
                    <tbody>
                        {paginatedLeads.length === 0 ? (
                            <tr>
                                <td colSpan={6} style={{ ...styles.td, textAlign: 'center', padding: '32px', color: '#9CA3AF' }}>
                                    {searchTerm
                                        ? 'No InvestorLead found matching your search'
                                        : 'No InvestorLead created yet. Click "Add Associate" to get started.'}
                                </td>
                            </tr>
                        ) : (
                            paginatedLeads.map((associate, index) => (
                                <tr
                                    //key={associate.user_id}
                                    key={`${associate.user_id}-${associate.investor_id}-${associate.property_id}`}

                                    style={{
                                        backgroundColor: index % 2 === 0 ? 'white' : '#F9FAFB',
                                        transition: 'background-color 0.2s',
                                    }}
                                >
                                    <td style={styles.td}>{associate.full_name}</td>
                                    <td style={styles.td}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <Mail size={16} color="#9CA3AF" />
                                            {associate.email}
                                        </div>
                                    </td>
                                    <td style={styles.td}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <Phone size={16} color="#9CA3AF" />
                                            {associate.mobile_number}
                                        </div>
                                    </td>
                                    {/* <td style={styles.td}>

                                        <span
                                            style={{
                                                ...styles.badge,
                                                ...(associate.property_title
                                                    ? styles.newBadge
                                                    : styles.pendingBadge),
                                            }}
                                        >
                                            {associate.property_title
                                                ? getProjectName(associate.property_title)
                                                : "Pending" || "General Inquiry"}
                                        </span>


                                    </td>

                                    <td style={styles.td}>
                                        <span style={{
                                            ...styles.badge,
                                            ...styles.newBadge
                                        }}>
                                            {usersMap[associate.handling_agent_id] || "Not Assign the Associate"}
                                        </span>
                                    </td> */}


                                    <td style={styles.td}>
                                        <span
                                            style={{
                                                ...styles.badge,
                                                ...(getStatusLabel(associate) === "Pending"
                                                    ? styles.pendingBadge
                                                    : styles.newBadge),
                                            }}
                                        >
                                            {getStatusLabel(associate)}
                                        </span>


                                    </td>

                                    <td style={styles.td}>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>

                                            <button
                                                onClick={() => openViewModal(associate)}
                                                style={{ ...styles.actionButton, color: '#8b306d' }}
                                                title="View"
                                            >
                                                <Eye size={18} />
                                            </button>

                                            <button onClick={() => handleEdit(associate)} style={{ ...styles.actionButton, color: '#42987e' }} title="Edit">
                                                <Pencil size={18} />
                                            </button>
                                            <button onClick={() => handleDelete(associate.user_id)} style={{ ...styles.actionButton, color: '#ff9d00ff' }} title="Delete">
                                                <Trash size={18} />
                                            </button>
                                        </div>
                                    </td>

                                </tr>
                            ))
                        )}
                    </tbody>
                </table>

                {/* ✅ Show Submit Button only if at least 1 checked */}
                {checkedUsers.length > 0 && (
                    <div style={{ marginTop: "16px", textAlign: "right" }}>
                        <button onClick={handleSubmitApprove} style={styles.submitButton}>
                            Approve the User
                        </button>
                    </div>
                )}
            </div>

            <Modal
                isOpen={isViewOpen}
                onRequestClose={closeViewModal}
                style={{
                    content: {
                        width: "80%",
                        maxWidth: "900px",
                        margin: "auto",
                        borderRadius: "12px",
                        padding: "24px",
                    },
                    overlay: {
                        backgroundColor: "rgba(0,0,0,0.4)",
                    },
                }}
            >
                {!showHistory && (
                    <>

                        <h2 style={{ marginBottom: "16px" }}>Investor Details</h2>

                        {/* 🔹 Property Details Table */}
                        <h4 style={{ marginBottom: "8px" }}>Property Details</h4>
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.th}>Name </th>
                                    <th style={styles.th}>Property Title</th>
                                    <th style={styles.th}>State/City</th>
                                    <th style={styles.th}>Mobile</th>
                                    <th style={styles.th}>Investment Range</th>
                                    <th style={styles.th}>Status</th>
                                    <th style={styles.th}>History</th>
                                </tr>
                            </thead>

                            <tbody>
                                {/* {selectedProperty ? (
                            <tr>
                                <td style={styles.td}>{selectedProperty.zone_desc}</td>
                                <td style={styles.td}>{selectedProperty.title}</td>
                                <td style={styles.td}>{selectedProperty.location}</td>
                                <td style={styles.td}>{selectedProperty.category}</td>
                                <td style={styles.td}>
                                    <span style={{ ...styles.badge, ...styles.newBadge }}>
                                        Active
                                    </span>
                                </td>
                            </tr>
                        ) : ( */}
                                {selectedInvestorLeads.length > 0 ? (
                                    selectedInvestorLeads.map((lead, i) => (
                                        <tr key={i}>
                                            <td style={styles.td}>
                                                {lead.full_name || "-"}
                                            </td>
                                            <td style={styles.td}>
                                                {lead.property_title || "Pending"}
                                            </td>
                                            <td style={styles.td}>
                                                {lead.state || "-"} /  {lead.city || "-"}
                                            </td>
                                            <td style={styles.td}>
                                                {lead.mobile_number || "-"}
                                            </td>
                                            <td style={styles.td}>
                                                {lead.investment_range}
                                            </td>
                                            <td style={styles.td}>
                                                <span style={{ ...styles.badge, ...styles.newBadge }}>
                                                    {lead.status}
                                                </span>
                                            </td>
                                            <td style={styles.td}>
                                                <span style={{ ...styles.badge, ...styles.newBadge }}>


                                                    <button
                                                        onClick={() => openHistory(lead.id)}
                                                        style={{ ...styles.actionButton, color: '#8b306d' }}
                                                        title="View"
                                                    >
                                                        <Eye size={18} />
                                                    </button>



                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4} style={{ ...styles.td, textAlign: "center" }}>
                                            No Property Assigned
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>

                        {/* 🔹 Agent Details Table */}
                        <h4 style={{ margin: "24px 0 8px" }}>Associate Details</h4>
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.th}>Associate Code</th>
                                    <th style={styles.th}>Name</th>
                                    <th style={styles.th}>Email</th>
                                    <th style={styles.th}>Mobile</th>
                                    {/* <th style={styles.th}>Status</th> */}
                                </tr>
                            </thead>

                            {/* <tbody>
                        {selectedAgent ? (
                            <tr>
                                <td style={styles.td}>{selectedAgent.full_name}</td>
                                <td style={styles.td}>{selectedAgent.email}</td>
                                <td style={styles.td}>{selectedAgent.mobile_number}</td>
                                <td style={styles.td}>
                                    <span style={{ ...styles.badge, ...styles.newBadge }}>
                                        Active
                                    </span>
                                </td>
                            </tr>
                        ) : (
                            <tr>
                                <td colSpan={4} style={{ ...styles.td, textAlign: "center" }}>
                                    No Agent Assigned
                                </td>
                            </tr>
                        )}
                    </tbody> */}

                            <tbody>
                                {selectedAgent.length > 0 ? (
                                    selectedAgent.map((agent, i) => (
                                        <tr key={i}>
                                            <td style={styles.td}>{agent.custom_id}  </td>
                                            <td style={styles.td}>{agent.full_name}</td>
                                            <td style={styles.td}>{agent.email}</td>
                                            <td style={styles.td}>{agent.mobile_number}</td>
                                            {/* <td style={styles.td}>
                                        <span style={{ ...styles.badge, ...styles.newBadge }}>
                                            Active
                                        </span>
                                    </td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4} style={{ ...styles.td, textAlign: "center" }}>
                                            No Associate Assigned
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>

                        {/* 🔹 Footer */}
                        <div style={{ marginTop: "24px", textAlign: "right" }}>
                            <button onClick={closeViewModal} style={styles.submitButton}>
                                Close
                            </button>
                        </div>
                    </>
                )}
                {showHistory && (
                    <div style={{ marginTop: 10 }}>

                        {/* Header */}
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: 15,
                            paddingBottom: 10,
                            borderBottom: "1px solid #eee"
                        }}>
                            <h3 style={{
                                margin: 0,
                                color: "#7f4070",
                                display: "flex",
                                alignItems: "center",
                                gap: 8
                            }}>
                                <RefreshCcw size={20} /> Lead History
                            </h3>

                            <button
                                onClick={() => setShowHistory(false)}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                    background: "#f3f4f6",
                                    border: "none",
                                    padding: "6px 12px",
                                    borderRadius: 6,
                                    cursor: "pointer"
                                }}
                            >
                                <ArrowLeft size={16} /> Back
                            </button>
                        </div>

                        {/* Loading */}
                        {loadingHistory ? (
                            <div style={{ textAlign: "center", padding: 30 }}>
                                Loading history...
                            </div>
                        ) : history.length === 0 ? (
                            <div style={{
                                textAlign: "center",
                                padding: 30,
                                color: "#999"
                            }}>
                                No history found
                            </div>
                        ) : (

                            <div style={{ position: "relative", paddingLeft: 25 }}>

                                {/* Timeline vertical line */}
                                <div style={{
                                    position: "absolute",
                                    left: 6,
                                    top: 0,
                                    bottom: 0,
                                    width: 2,
                                    background: "#e5e7eb"
                                }} />

                                {history.map((item, index) => (
                                    <div
                                        key={item.id}
                                        style={{
                                            position: "relative",
                                            marginBottom: 20
                                        }}
                                    >

                                        {/* Timeline dot */}
                                        <div style={{
                                            position: "absolute",
                                            left: -2,
                                            top: 10,
                                            width: 14,
                                            height: 14,
                                            borderRadius: 7,
                                            background: "#7f4070",
                                            border: "3px solid white"
                                        }} />

                                        {/* Card */}
                                        <div style={{
                                            background: "#ffffff",
                                            borderRadius: 12,
                                            padding: 14,
                                            boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                                            border: "1px solid #f1f1f1",
                                            marginLeft: 15
                                        }}>

                                            {/* Status */}
                                            <div style={{
                                                fontWeight: 600,
                                                color: "#7f4070",
                                                marginBottom: 6,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 6
                                            }}>
                                                {item.old_status?.toUpperCase()}
                                                <span style={{
                                                    background: "#ecfdf5",
                                                    color: "#047857",
                                                    padding: "2px 8px",
                                                    borderRadius: 20,
                                                    fontSize: 12
                                                }}>
                                                    →
                                                </span>
                                                {item.new_status?.toUpperCase()}
                                            </div>

                                            {/* Remarks */}
                                            {item.remarks && (
                                                <div style={{
                                                    color: "#374151",
                                                    marginBottom: 8,
                                                    fontSize: 14
                                                }}>
                                                    {item.remarks}
                                                </div>
                                            )}

                                            {/* Footer */}
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                fontSize: 12,
                                                marginTop: 8
                                            }}>

                                                <div style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 6,
                                                    color: "#4a8c7c",
                                                    fontWeight: 600
                                                }}>
                                                    <User size={14} />
                                                    {item.agent_name}
                                                </div>

                                                <div style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 6,
                                                    color: "#6B7280"
                                                }}>
                                                    <Clock size={14} />
                                                    {new Date(
                                                        item.created_at
                                                    ).toLocaleString()}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}


            </Modal>


            {/* Stats */}
            <div style={styles.stats}>
                Total Associates: {filteredAssociates.length}
                {searchTerm && ` (filtered from ${InvestorLead.length})`}
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    borderTop: "1px solid #E5E7EB",
                    background: "#F9FAFB",
                }}
            >
                <div style={{ fontSize: 14, color: "#6B7280" }}>
                    Showing {startIndex + 1}–
                    {Math.min(startIndex + itemsPerPage, filteredAssociates.length)} of{" "}
                    {filteredAssociates.length}
                </div>

                <div style={{ display: "flex", gap: "6px" }}>
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((p) => p - 1)}
                        style={{
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "1px solid #ddd",
                            background: currentPage === 1 ? "#eee" : "#fff",
                            cursor: "pointer",
                        }}
                    >
                        Prev
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                        .slice(
                            Math.max(0, currentPage - 3),
                            Math.min(totalPages, currentPage + 2)
                        )
                        .map((page) => (
                            <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                style={{
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    border: "1px solid #ddd",
                                    background:
                                        currentPage === page ? "#8b306d" : "#fff",
                                    color: currentPage === page ? "#fff" : "#333",
                                    cursor: "pointer",
                                }}
                            >
                                {page}
                            </button>
                        ))}

                    <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((p) => p + 1)}
                        style={{
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "1px solid #ddd",
                            background:
                                currentPage === totalPages ? "#eee" : "#fff",
                            cursor: "pointer",
                        }}
                    >
                        Next
                    </button>
                </div>
            </div>

        </div>
    );
};
